import CryptoJS from "crypto-js";

const ENCRYPTION_KEY =
  "5b7qPgo/T4vV0gD+/M4PWpsy6qPpxBZN5/Gj7dqv8GjgvTbZQSzn5UL9gyzHAleR";

export function setSessionStorage(key, data) {
  try {
    const stringData = JSON.stringify(data);
    const encryptedData = CryptoJS.AES.encrypt(
      stringData,
      ENCRYPTION_KEY
    ).toString();
    sessionStorage.setItem(key, encryptedData);
  } catch (error) {
    console.error("Error setting sessionStorage:", error);
  }
}

export function getSessionStorage(key) {
  try {
    const encryptedData = sessionStorage.getItem(key);
    if (!encryptedData) return null;

    const bytes = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
  } catch (error) {
    console.error("Error getting sessionStorage:", error);
    return null;
  }
}

export function clearAllSessionStorage() {
  sessionStorage.clear();
}

export function clearSpecificSessionStorage(keys = []) {
  keys.forEach((key) => sessionStorage.removeItem(key));
}
